import styled from 'styled-components';

const Section = styled.div`
  margin-top: 16px;
  width: 100%;
`;

const StatusContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 10px;
`;

const StatusCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  min-width: 130px;
  padding: 12px 16px;

  border-radius: 12px;

  background: ${(props) => props.theme.colors.background_secondary};
  border: 1px solid ${(props) => props.theme.colors.outline};

  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
`;

const ErrorWrapper = styled.div`
  min-height: 40px;
`;

const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  margin-top: 8px;
  padding: 8px 12px;

  border-radius: 8px;

  background: rgba(255, 59, 48, 0.12);
  border: 1px solid rgba(255, 59, 48, 0.4);

  color: #ff3b30;
  font-size: 13px;
  font-weight: 500;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const StatusLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.inactive};
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const StatusValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.text};
`;

const Status = styled.div`
  margin-top: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 24px;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  padding: 18px;
`;

const RecordControls = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px
`;

const AudioWrapper = styled.div`
  width: 100%;
  background: ${(props) => props.theme.colors.background_secondary};
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 20px;
`;

const RecordIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-top: 4px;
  background: ${(props) => props.theme.colors.outline};
  color: ${(props) => props.theme.colors.white};

  svg {
    width: 18px;
    height: 18px;
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  input[type="radio"] {
    display: none;
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
  }

  .checkbox {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    border: 2px solid ${(props) => props.theme.colors.inactive};
    border-radius: 50%;
    position: relative;
  }

  input[type="radio"]:checked + label .checkbox {
    background: ${(props) => props.theme.colors.main_cta};
  }

  input[type="radio"]:checked + label .checkbox::after {
    content: "";
    position: absolute;
    width: 6px;
    height: 6px;
    background: white;
    border-radius: 50%;
    top: 3px;
    left: 3px;
  }
`;
const Label = styled.span`
  font-size: 16px;
  color: ${(props) => props.theme.colors.text};
  text-align: center;
`;

const SubLabel = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.inactive};
  text-align: center;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 4px;

  .text {
    padding-left: 16px;
  }
`;

const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  width: 100%;
  max-width: 320px;
  min-height: 104px;
  padding: 16px;
  border: 2px dashed red;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.2s ease;

  &:hover,
  &:focus {
    background: rgba(255, 0, 0, 0.2);
  }

  @media (min-width: 400px) {
    width: 213px;
    height: 104px;
    padding: 10px;
  }
`;

const ModernButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 8px 18px;
  border-radius: 10px;
  border: none;

  background: linear-gradient(135deg, #f6f64c, #ebeb1b);
  color: #1a1a1a;

  font-weight: 600;
  font-size: 14px;

  cursor: pointer;

  box-shadow: 0 4px 10px rgba(0,0,0,0.15);

  transition: all 0.2s ease;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(0,0,0,0.2);
  }

  &:active {
    transform: scale(0.97);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
  }
`;
const AudioTypeContainer = styled.div`
  display: flex;
  gap: 0;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid ${(props) => props.theme.colors.outline};
`;

const AudioTypeOption = styled.label<{ active: boolean }>`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  background: ${(props) => (
    props.active ? props.theme.colors.main_cta : 'transparent'
  )};

  color: ${(props) => (
    props.active ? '#1a1a1a' : props.theme.colors.text
  )};

  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (
    props.active
      ? props.theme.colors.main_cta
      : 'rgba(255,255,255,0.05)'
  )};
  }
`;

const HiddenRadio = styled.input`
  display: none;
`;

const PreviewCard = styled.div`
  margin-top: 12px;
  padding: 16px;
  border-radius: 12px;

  background: ${(props) => props.theme.colors.background_secondary};
  border: 1px solid ${(props) => props.theme.colors.outline};

  box-shadow: 0 4px 12px rgba(0,0,0,0.18);
`;

const PreviewHeader = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  color: ${(props) => props.theme.colors.text};
`;

const PlayerWrapper = styled.div`
  margin-bottom: 14px;

  audio {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    background: #f0f4ff;
  }
`;

const PreviewActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;
const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 18px;
  border-radius: 8px;
  border: none;

  background: ${(props) => props.theme.colors.main_cta};
  color: #1a1a1a;
  font-weight: 600;

  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  }
      /* ✅ ADD THIS */
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none; /* 🔥 important */
    transform: none;
    box-shadow: none;
  }
`;

const EmptyMessage = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${(props) => props.theme.colors.inactive};
  `;
const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 18px;
  border-radius: 8px;

  border: 1px solid ${(props) => props.theme.colors.outline};
  background: transparent;
  color: ${(props) => props.theme.colors.text};

  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    border-color: ${(props) => props.theme.colors.main_cta};
    transform: translateY(-1px);
  }
`;

export default {
  Card,
  RecordIcon,
  Label,
  SubLabel,
  Actions,
  RowContainer,
  ItemWrapper,
  AudioWrapper,
  RecordControls,
  ModalBody,
  Section,
  Status,
  ModernButton,
  StatusContainer,
  StatusCard,
  StatusLabel,
  StatusValue,
  ErrorMessage,
  AudioTypeContainer,
  AudioTypeOption,
  HiddenRadio,
  PreviewCard,
  PreviewHeader,
  PlayerWrapper,
  PreviewActions,
  PrimaryButton,
  SecondaryButton,
  ErrorWrapper,
  EmptyMessage,
};
